import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { I18nextProvider } from 'react-i18next';
import { store } from "./app/store";
import { Provider } from 'react-redux';
import UserState from "./context/users/UserState";
import ThemeState from "./context/theme/ThemeState";
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import i18n from "./config/i18n";
import './fabric.min.css'
import 'froala-editor/js/froala_editor.pkgd.min.js';

import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/css/plugins/colors.min.css'
import 'froala-editor/css/plugins/table.min.css'
import 'froala-editor/css/third_party/spell_checker.min.css'


import 'froala-editor/js/plugins/colors.min.js'
import 'froala-editor/js/plugins/code_beautifier.min.js'
import 'froala-editor/js/plugins/font_family.min.js'
import 'froala-editor/js/plugins/font_size.min.js'
import 'froala-editor/js/plugins.pkgd.min.js';
import 'froala-editor/js/plugins/paragraph_format.min.js'
import 'froala-editor/js/plugins/align.min.js'
import 'froala-editor/js/plugins/lists.min.js'
import 'froala-editor/js/plugins/table.min.js'
import 'froala-editor/js/plugins/line_height.min.js'
// import 'froala-editor/js/third_party/spell_checker.min.js'

import '../node_modules/font-awesome/css/font-awesome.min.css';
import '../node_modules/underscore/underscore-min.js';
import ToastState from './context/toast/ToastState';
import LoaderState from './context/loader/LaoderState';
import { BrowserRouter } from 'react-router-dom';
import FrameBuster from './FrameBuster.jsx';

initializeIcons();

const root = ReactDOM.createRoot(document.getElementById('root'));
const isFrameBusterEnabled = process.env.REACT_APP_ENABLE_FRAMEBUSTER === 'true';
root.render(
  <>{
    window.location.pathname.includes("/ping") ?
      <div>OK</div> :
      <> {isFrameBusterEnabled && <FrameBuster />}<App /></>
  }
  </>
);
